import { render, staticRenderFns } from "./AddSettlement.vue?vue&type=template&id=56362380&"
import script from "./AddSettlement.vue?vue&type=script&lang=js&"
export * from "./AddSettlement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports